import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

const headers = new HttpHeaders({ 'responseType': 'arraybuffer' });

@Injectable({
  providedIn: 'root'
})
export class FulfillService {
  constructor(private httpClient: HttpClient) { }

  getImageSize(parts: string) {
    const arrayParts = parts.split('###');
    return this.httpClient.post<any>('/api/Fulfill/GetImageSizes/', { shareLinks: arrayParts });
  }

  getAvailablePrintConfigs() {
    return this.httpClient.get<any>('/api/Fulfill/getAvailablePrintConfigs');
  }

  getPrintifyFulfillConfigs() {
    return this.httpClient.get<any>('/api/Fulfill/GetPrintifyFulfillConfigs');
  }

  getBlueprints() {
    return this.httpClient.get<any>('/api/Fulfill/GetPrintifyBluePrints');
  }

  getPrintifyProviders(blueprintId: number) {
    return this.httpClient.get<any>(`/api/Fulfill/getPrintifyProviders?blueprintId=${blueprintId}`);
  }

  getAvailablePrintLogistics() {
    return this.httpClient.get<any>('/api/Fulfill/getAvailablePrintLogistics');
  }

  getBurgerPrintProducts() {
    return this.httpClient.get<any>('/api/Fulfill/GetBurgerPrintProducts');
  }

  downloadExportFileForPrintify(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForPrintify', saleRecords);
  }

  downloadExportFileForFlashship(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForFlashship', saleRecords);
  }

  downloadExportFileForBestPrintCare(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForBestPrintCare', saleRecords);
  }

  downloadExportFileForPrintLogistic(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForPrintLogistic', saleRecords);
  }

  downloadExportFileForBeeful(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForBeeful', saleRecords);
  }

  downloadExportFileForBurgerPrint(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForBurgerPrint', saleRecords);
  }

  downloadExportFileForMerchize(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForMerchize', saleRecords);
  }

  downloadExportFileForGeargag(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForGeargag', saleRecords);
  }

  downloadExportFileForPrintWay(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForPrintWay', saleRecords);
  }

  downloadExportFileForArtsAdd(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForArtsAdd', saleRecords);
  }

  downloadExportFileForGearment(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForGearment', saleRecords);
  }

  downloadExportFileForOnePrint(saleRecords: any[]) {
    return this.downloadExportFile('downloadExportFileForOnePrint', saleRecords);
  }

  private downloadExportFile(endpoint: string, saleRecords: any[]) {
    const selectedSaleRecordIds = saleRecords
      .filter(record => record.isSelected)
      .map(record => record.orderItemId);

    let params = new URLSearchParams();
    params.set('selectedOrderItemIds', selectedSaleRecordIds.join('@@@'));

    return this.httpClient.get(
      `/api/Fulfill/${endpoint}?${params.toString()}`,
      { responseType: 'arraybuffer', headers: headers }
    );
  }

  selectedSaleRecordsToUrlParams(saleRecords: any[]) {
    const selectedSaleRecordIds = saleRecords
      .filter(record => record.isSelected)
      .map(record => record.orderItemId);

    let params = new URLSearchParams();
    params.set('selectedOrderItemIds', selectedSaleRecordIds.join('@@@'));
    return params;
  }

  buyMultipleRecordsByPrintifyApi(saleRecords: any[]) {
    const params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(`/api/Fulfill/SendOrderPrintifyApi?${params.toString()}`, {});
  }

  buyMultipleRecordsMerchizeApi(saleRecords: any[]) {
    const params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(`/api/Fulfill/SendOrderToMerchizeApi?${params.toString()}`, {});
  }

  sendOrderBestPrintCareApi(saleRecords: any[]) {
    const params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(`/api/Fulfill/sendOrderBestPrintCareApi?${params.toString()}`, {});
  }

  sendOrderPrintifyApi(record: any) {
    return this.httpClient.post(`api/Fulfill/sendOrderPrintifyApi?providerId=&productId=&selectedOrderItemIds=${record.orderItemId}`, {});
  }

  sendOrderFlashshipApi(saleRecords: any[]) {
    const params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(`/api/Fulfill/sendOrderFlashshipApi?${params.toString()}`, {});
  }

  sendOrderPrintwayApi(saleRecords: any[]) {
    const params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(`/api/Fulfill/sendOrderPrintwayApi?${params.toString()}`, {});
  }

  addColor(newColor: string) {
    return this.httpClient.post(`/api/Fulfill/addColor?newColor=${newColor}`, {});
  }

  addSize(newSize: string) {
    return this.httpClient.post(`/api/Fulfill/addSize?newSize=${newSize}`, {});
  }

  sendOrderBeefulApi(saleRecords: any[]) {
     const params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(`/api/Fulfill/sendOrderBeefulApi?${params.toString()}`, {});
  }

  sendOrderBurgerPrintApi(saleRecords: any[]) {
    const params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(`/api/Fulfill/sendOrderBurgerPrintApi?${params.toString()}`, {});
  }

  sendOrderLenfulApi(saleRecords: any[]) {
    const params = this.selectedSaleRecordsToUrlParams(saleRecords);
    return this.httpClient.post(`/api/Fulfill/sendOrderLenfulApi?${params.toString()}`, {});
  }
}
